import React, { useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import debounce from 'lodash.debounce';
import IconButton from '../IconButton/IconButton';
import { Icon } from '@modulor/react';
import { ReactComponent as ArrowIconSCCOM } from '../../../AppSCCOM/assets/icons/arrow.svg'; // no modulor icon
import { getDataTestAttrs } from '../../../utils/testing-locators';
import { BUTTON_TO_TOP } from '../../../constants/dataTestIds';
import { useIsSSCOMBrand } from '../../../hooks/useIsSSCOMBrand';
import styles from './ToTopButton.module.css';
import { useIsDesktopLayout } from '../../../hooks/useMediaQuery';

export const ToTopButton = ({ className }) => {
  const [isVisible, setIsVisible] = useState(false);
  const isSCCOM = useIsSSCOMBrand();
  const isDesktop = useIsDesktopLayout();

  const toggleVisibility = useCallback(() => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, []);

  const clickHandler = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    const toggleVisibilityHandler = debounce(toggleVisibility, 200);

    window.addEventListener('scroll', toggleVisibilityHandler);
    return () => window.removeEventListener('scroll', toggleVisibilityHandler);
  }, [toggleVisibility]);

  return (
    <IconButton
      onClick={clickHandler}
      className={classNames(
        styles.component,
        isSCCOM && styles.component_sccom,
        isVisible && styles.visible,
        className
      )}
      {...getDataTestAttrs(BUTTON_TO_TOP)}
    >
      {isSCCOM ? (
        <ArrowIconSCCOM className={styles.icon_sccom} />
      ) : (
        <Icon
          name="back_android"
          className={styles.icon}
          size={isDesktop ? 32 : 27}
        />
      )}
    </IconButton>
  );
};

export default ToTopButton;
